var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStaff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3603 28.7998C29.7473 28.7998 32.0365 27.8516 33.7243 26.1638C35.4121 24.476 36.3604 22.1868 36.3604 19.7998C36.3604 17.4129 35.4121 15.1237 33.7243 13.4358C32.0365 11.748 29.7473 10.7998 27.3603 10.7998C24.9734 10.7998 22.6842 11.748 20.9964 13.4358C19.3086 15.1237 18.3604 17.4129 18.3604 19.7998C18.3604 22.1868 19.3086 24.476 20.9964 26.1638C22.6842 27.8516 24.9734 28.7998 27.3603 28.7998Z",
    stroke: "#0095DF",
    strokeWidth: 1.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.04 42.9297V38.4297C14.04 36.0427 14.9882 33.7536 16.6761 32.0658C18.3639 30.3779 20.6531 29.4297 23.04 29.4297H32.0401C34.427 29.4297 36.7162 30.3779 38.404 32.0658C40.0918 33.7536 41.04 36.0427 41.04 38.4297V42.9297",
    stroke: "#0095DF",
    strokeWidth: 1.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2799 30.2404C45.7121 30.2404 47.0856 29.6715 48.0982 28.6588C49.1109 27.6461 49.6799 26.2726 49.6799 24.8404C49.6799 23.4083 49.1109 22.0348 48.0982 21.0221C47.0856 20.0094 45.7121 19.4404 44.2799 19.4404C42.8477 19.4404 41.4742 20.0094 40.4615 21.0221C39.4488 22.0348 38.8799 23.4083 38.8799 24.8404C38.8799 26.2726 39.4488 27.6461 40.4615 28.6588C41.4742 29.6715 42.8477 30.2404 44.2799 30.2404Z",
    stroke: "#0095DF",
    strokeWidth: 1.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7998 31.3202C38.8798 30.7802 39.8726 30.2402 41.4002 30.2402H47.1603C48.6879 30.2402 50.153 30.8471 51.2332 31.9273C52.3134 33.0075 52.9202 34.4726 52.9202 36.0002V38.8802",
    stroke: "#0095DF",
    strokeWidth: 1.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3599 41.0409C45.8999 41.0409 52.3799 40.5009 52.9199 38.8809",
    stroke: "#0095DF",
    strokeWidth: 1.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.7203 30.2404C8.28814 30.2404 6.91468 29.6715 5.90202 28.6588C4.88935 27.6461 4.32043 26.2726 4.32043 24.8404C4.32043 23.4083 4.88935 22.0348 5.90202 21.0221C6.91468 20.0094 8.28814 19.4404 9.7203 19.4404C11.1524 19.4404 12.5259 20.0094 13.5385 21.0221C14.5512 22.0348 15.1201 23.4083 15.1201 24.8404C15.1201 26.2726 14.5512 27.6461 13.5385 28.6588C12.5259 29.6715 11.1524 30.2404 9.7203 30.2404Z",
    stroke: "#0095DF",
    strokeWidth: 1.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2002 31.3202C15.1202 30.7802 14.1275 30.2402 12.5999 30.2402H6.84001C5.31243 30.2402 3.8474 30.8471 2.76723 31.9273C1.68705 33.0075 1.0802 34.4726 1.0802 36.0002V38.8802",
    stroke: "#0095DF",
    strokeWidth: 1.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.63986 41.0409C8.09988 41.0409 1.62006 40.5009 1.08008 38.8809",
    stroke: "#0095DF",
    strokeWidth: 1.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaff);
export default __webpack_public_path__ + "static/media/staff.9a0bf2430cf7938752b7ed88134d957a.svg";
export { ForwardRef as ReactComponent };